module.exports = __webpack_public_path__ + "assets/d269bfac27204fa84c50c9eb8202cde7.svg";


//////////////////
// WEBPACK FOOTER
// ./app/users/assets/users.svg
// module id = 824
// module chunks = 0